import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { BounceLoader } from 'react-spinners';
import { bindActionCreators } from 'redux';
import { translate } from 'react-i18next';
import { Button } from '@tillersystems/stardust';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import Media from 'react-media';

import * as sfDataActions from '../../services/DataServices/SFDataService/actions';

import getAllUrlParams from '../../helpers/url';

import { Theme, Page, Slider, Slide, Image } from '../../components';

const { object, func } = PropTypes;
/**
 * Welcome Page
 *
 * This component is in charge of displaying
 * a the welcome page
 *
 * @return {jsx}
 */

class Welcome extends Component {
  /**
   * PropTypes validation
   */
  static propTypes = {
    customerInformations: object,
    customerDetails: object,
    customerAddress: object,
    opportunity: object,
    actions: object.isRequired,
    history: object.isRequired,
    t: func.isRequired,
  };

  /**
   * Default Props
   */
  static defaultProps = {
    customerInformations: null,
    customerDetails: null,
    customerAddress: null,
    opportunity: null,
  };

  state = {
    stageValue: 'Page 1',
    stageNumber: 1,
    loading: false,
    slideIndex: 0,
  };

  componentDidMount() {
    const { customerInformations, customerDetails, customerAddress, actions } = this.props;

    // Initialize data for fetching and setting
    const accountId = `?accountId=${getAllUrlParams(window.location.href).account}`;
    const opportunityId = `?opportunityId=${getAllUrlParams(window.location.href).opportunity}`;
    // check if opportunity / customerDetails / customerAddress are empty
    if (customerInformations === null || customerDetails === null || customerAddress === null) {
      actions.fetchSalesforceData(accountId, opportunityId);
      this.setState({
        loading: true,
      });
    }
    // if (opportunity !== undefined && opportunity) {
    //   if (opportunity._stageValue !== null) {
    //     if (localStorage.getItem('force') === 'true') {
    //       localStorage.setItem('force', 'false');
    //       history.push('/informations');
    //     }
    //   }
    // }
  }

  componentWillReceiveProps(nextProps) {
    const {
      customerInformations,
      customerDetails,
      customerAddress,
      opportunity,
      actions,
    } = this.props;
    const { stageValue, stageNumber } = this.state;
    if (
      nextProps.customerInformations !== customerInformations ||
      nextProps.customerDetails !== customerDetails ||
      nextProps.customerAddress !== customerAddress
    ) {
      this.setState({
        loading: false,
      });
    }
    if (nextProps.opportunity._stageValue === null && opportunity !== nextProps.opportunity) {
      actions.opportunityNeedUpdate(
        getAllUrlParams(window.location.href).opportunity,
        stageValue,
        stageNumber,
      );
    }
  }

  setSlideIndex = slideIndex => {
    this.setState({ slideIndex });
  };

  render() {
    const { loading, slideIndex } = this.state;
    const { t, customerInformations } = this.props;
    return loading ? (
      <div className="Loader-container">
        <BounceLoader color="#1F95CE" loading={loading} />
      </div>
    ) : (
      <Media query={{ maxWidth: Theme.breakpoints.md }}>
        {matches =>
          matches ? (
            <React.Fragment>
              <Slider slideIndex={slideIndex} onSlideChange={this.setSlideIndex}>
                <Slide>
                  <Slide.Image
                    src="/img/illu_00.png"
                    srcSet="/img/illu_00@2x.png 2x, /img/illu_00.png 1x"
                  />
                  <Slide.Title>{t('carousel.welcome.title')}</Slide.Title>
                  <Slide.Paragraph>{t('carousel.welcome.main')}</Slide.Paragraph>
                </Slide>
                <Slide>
                  <Slide.Image
                    src="/img/illu_01.png"
                    srcSet="/img/illu_01@2x.png 2x, /img/illu_01.png 1x"
                  />
                  <Slide.Title>{t('carousel.store.title')}</Slide.Title>
                  <Slide.Paragraph>{t('carousel.store.main')}</Slide.Paragraph>
                </Slide>
                <Slide>
                  <Slide.Image
                    src="/img/illu_02.png"
                    srcSet="/img/illu_02@2x.png 2x, /img/illu_02.png 1x"
                  />
                  <Slide.Title>{t('carousel.order.title')}</Slide.Title>
                  <Slide.Paragraph>{t('carousel.order.main')}</Slide.Paragraph>
                </Slide>
                <Slide>
                  <Slide.Image
                    src="/img/illu_03.png"
                    srcSet="/img/illu_03@2x.png 2x, /img/illu_03.png 1x"
                  />
                  <Slide.Title>{t('carousel.delivery.title')}</Slide.Title>
                  <Slide.Paragraph>{t('carousel.delivery.main')}</Slide.Paragraph>
                </Slide>
                <Slide>
                  <Slide.Image
                    src="/img/illu_04.png"
                    srcSet="/img/illu_04@2x.png 2x, /img/illu_04.png 1x"
                  />
                  <Slide.Title>{t('carousel.discover.title')}</Slide.Title>
                  <Slide.Paragraph>{t('carousel.discover.main')}</Slide.Paragraph>
                </Slide>
              </Slider>
              <div style={{ padding: '16px' }}>
                <Link to="/informations">
                  <Button big primary fluid>
                    {t('carousel.button')}
                  </Button>
                </Link>
              </div>
            </React.Fragment>
          ) : (
            <Page textCenter>
              <Image src="/img/illu_first.svg" alt="" size="180px" />
              <Page.Title>
                {t('welcomePage.heading')}{' '}
                {customerInformations ? customerInformations.getName() : ''} !
              </Page.Title>
              <Page.Paragraph>{t('welcomePage.content')}</Page.Paragraph>
              <Page.Paragraph>{t('welcomePage.catchPhrase')}</Page.Paragraph>
              <Link to="/informations">
                <Button big primary fluid>
                  {t('welcomePage.button')}
                </Button>
              </Link>
            </Page>
          )
        }
      </Media>
    );
  }
}

function mapStateToProps(state) {
  return {
    customerInformations: state.customerInformations,
    customerDetails: state.customerDetails,
    customerAddress: state.customerAddress,
    opportunity: state.opportunity,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...sfDataActions }, dispatch),
  };
}

const WelcomeConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
)(Welcome);

export default translate('translations')(WelcomeConnect);



// WEBPACK FOOTER //
// ./src/pages/Welcome/index.js